/* eslint-disable no-undef, no-unused-vars */
export enum EmulatorEvent {
  // public enum EmulatorEvent {
  //     EMULATOR_CONNECTED,
  //     EMULATOR_UNCHANGED,
  //     EMULATOR_DISCONNECTED,
  //     EMULATOR_LOCATION_UPDATED,
  //     EMULATOR_STATUS_UPDATED,
  //     EMULATOR_TRIP_STARTED,
  //     EMULATOR_TRIP_ENDED,
  //     EMULATOR_TRIP_CANCELLED,
  //     EMULATOR_TRIP_PAUSED,
  //     EMULATOR_TRIP_RESUMED,
  //     EMULATOR_TRIP_DETAILS_UPDATED,
  // }

  EMULATOR_CONNECTED = 'EMULATOR_CONNECTED',
  EMULATOR_CONNECTED_NO_TRIP = 'EMULATOR_CONNECTED_NO_TRIP',
  EMULATOR_LOCATION_UPDATED = 'EMULATOR_LOCATION_UPDATED',
  EMULATOR_TRIP_CANCELLED = 'EMULATOR_TRIP_CANCELLED',
  EMULATOR_TRIP_DETAILS_UPDATED = 'EMULATOR_TRIP_DETAILS_UPDATED',
  TRIP_COMPLETED = 'TRIP_COMPLETED'
}

export enum EmulatorsSSEEvent {
  //  EMULATORS_CONNECTED,
  //  EMULATOR_UPDATED,
  //  EMULATOR_DELETED,
  //  EMULATOR_ADDED
  EMULATORS_CONNECTED = 'EMULATORS_CONNECTED',
  EMULATOR_UPDATED = 'EMULATOR_UPDATED',
  EMULATOR_DELETED = 'EMULATOR_DELETED',
  EMULATOR_ADDED = 'EMULATOR_ADDED'
}
